import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnDestroy, SimpleChanges, OnChanges, Output, EventEmitter, ElementRef } from '@angular/core';
import { MatTable, MatDialog } from '@angular/material';
import { CompanyRef, Uploadable, Parameter, ContributionTypesEnum } from '@akiba/models_bimbo';
import { SelectionModel } from '@angular/cdk/collections';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';

@Component({
  selector: 'app-rs-parameters',
  templateUrl: './rs-parameters.component.html',
  styleUrls: ['./rs-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RsParametersComponent implements OnInit, OnDestroy, OnChanges {

  generalSubscription: Subscription = null;

  @ViewChild('companiesTable', { static: false }) companiesTable: MatTable<CompanyRef>;
  displayedCompanyColumns: string[] = ['companyID', 'companyName', 'taxationIdentificationNumber', 'select'];

  selectionCompanies: SelectionModel<CompanyRef>;
  selectionCompaniesSubscription: Subscription = null;
  appLogicChangesSubscription: Subscription = null;
  revenueAmount: number = 0;
  iRFileLink: string = '';
  iRExecutionDate: string = '';
  iRStatus: string;
  iRFileStatusRef: firebase.database.Reference;
  originalDRDistributionValue: boolean;

  @ViewChild('statusButton', { static: false }) statusButton: ElementRef;
  @Input() contentLocation: AppState;
  @Input() modParameter: Parameter;

  @Output() hideActionButtons = new EventEmitter<boolean>();

  constructor(public logicService: LogicService, public dialog: MatDialog, private uiService: UiService, private dataService: DataSourceService) {
    this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);

    this.generalSubscription = this.logicService.dataManager.generalDataLoader.changes.subscribe(p => {

      if (p && p.response) {

        this.doSubscriptions();

      }

    });

    this.logicService.dataManager.generalDataLoader.load();

  }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    this.originalDRDistributionValue = this.modParameter.hasDRDistribution;
    this.reset();
    this.doSubscriptions();
  }

  doSubscriptions() {

    if (this.logicService.dataManager.generalDataLoader.companies && this.modParameter) {

      this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);

      if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
        this.selectionCompaniesSubscription.unsubscribe();
        this.selectionCompaniesSubscription = null;
      }

      this.logicService.dataManager.generalDataLoader.companies.forEach(cr => {
        const index = this.modParameter.savingParameter.includedCompanies.map(ic => ic.companyID).indexOf(cr.companyID);
        if (index >= 0) {
          this.selectionCompanies.select(cr);
        }
      });

      this.selectionCompaniesSubscription = this.selectionCompanies.changed.subscribe(x => {

        if (x.added.length) {

          x.added.forEach(element => {
            const index = this.modParameter.savingParameter.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
            if (index < 0) {
              this.modParameter.savingParameter.includedCompanies.push(element);
            }
          });

        } else if (x.removed.length) {

          x.removed.forEach(element => {
            const index = this.modParameter.savingParameter.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
            this.modParameter.savingParameter.includedCompanies.splice(index, 1);
          });

        }

      });

      try {
        if (this.companiesTable) {
          this.companiesTable.renderRows();
        }
      } catch (error) {
        console.log(this.companiesTable);
      }
    }

  }

  cancelSubscriptions() {

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
      this.appLogicChangesSubscription = null;
    }

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
      this.selectionCompaniesSubscription = null;
    }

  }

  switchTo(anIndex: number) {
    this.contentLocation.savingParametersIndex = anIndex;

    this.hideActionButtons.emit(anIndex === 3);

    if (anIndex === 3) this._updateDRStatus();
  }

  detectFiles(event: any, type: string) {

    if (!event.target.files.length) {
      return;
    }

    const file: File = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const aDate = new Date().getTime().toString();
      this.modParameter.savingParameter.fileUploaded = new Uploadable();
      this.modParameter.savingParameter.fileUploaded.bucket = 'files/' + this.modParameter.parametersID + '_' + file.name;
      this.modParameter.savingParameter.fileUploaded.name = file.name;
      this.modParameter.savingParameter.fileUploaded.file = file;
    };

    reader.readAsDataURL(file);

  }

  cancel() {
    this.reset();
  }

  reset() {

    this.selectionCompanies.clear();

  }

  get downloadURL(): string | null {
    const p = this.modParameter;
    if (p) {
      return p.savingParameter.downloadLink();
    }
    return null;
  }

  ngOnDestroy(): void {

    this.cancelSubscriptions();

  }

  cancelInvestmentReturn(rejection: boolean = false) {

    this.revenueAmount = 0;
    if (rejection) {
      const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, { data: {
        message: '¿Está seguro que desea descartar la distribución de réditos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }})

      dialogConfirmation.afterClosed().subscribe(async result => {
        if (result) {

          this.uiService.showSpinner();
          const response = await this.dataService.rejectInvestmentReturn(ContributionTypesEnum.CAR);

          this.uiService.stopSpinner();

          this.dialog.open(InfoDialogComponent, { data: {
            message: 'Cálculo de rendimiento eliminado',
            close: 'Aceptar'
          }});

        }
      });
    } else {
      this.switchTo(0);
    }
  }

  async calculateDR() {
    try {

      if (typeof this.revenueAmount !== 'number') {
        this.dialog.open(InfoDialogComponent, { data: {
          message: 'El dato ingresado es inválido. Inténtelo nuevamente',
          close: 'Aceptar'
        }});

        return;
      }

      this.uiService.showSpinner();

      this.revenueAmount = Number(this.revenueAmount);

      const companyIDs: string[] = this.modParameter.savingParameter.includedCompanies.map(c => c.companyID);
      const response = await this.dataService.createDRFile(companyIDs, ContributionTypesEnum.CAR, Number(this.revenueAmount));

      this.uiService.stopSpinner();
  
      this.dialog.open(InfoDialogComponent, { data: {
        message: 'Se inició correctamente la generación del archivo de validación',
        close: 'Aceptar'
      }});

      this.iRFileLink = '';
      
    } catch (error) {
      this.dialog.open(InfoDialogComponent, { data: {
        message: 'Ocurrió un error al intentar generar el archivo de validación',
        close: 'Aceptar'
      }});
      console.log(error);
    }
  }

  async getDRValidationFile() {
    this.uiService.showSpinner();
    const status: any = await this.dataService.getInvestmentReturnValidationFile(ContributionTypesEnum.CAR);

    if (!status.result) {
      this.uiService.stopSpinner();
    } else {

      if (status.result[Object.keys(status.result)[0]]['url']) {
        this.iRExecutionDate = Object.keys(status.result)[0];
        this.iRFileLink = status.result[Object.keys(status.result)[0]]['url'];
      } else {
        this.iRFileLink = '';
      }
      
      this.uiService.stopSpinner();
    }
  }

  downloadIRFile() {
    window.open(this.iRFileLink);
  }

  async distributeDR() {
    try {

      const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, { data: {
        message: '¿Está seguro que desea iniciar la distribución de rendimientos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }})

      dialogConfirmation.afterClosed().subscribe(async result => {
        if (result) {

          this.uiService.showSpinner();
          
          const response = await this.dataService.distributeDR(ContributionTypesEnum.CAR, this.iRExecutionDate).catch(async error => {
            console.log('error', error);
          });
        
      
          this.uiService.stopSpinner();
    
          this.dialog.open(InfoDialogComponent, { data: {
            message: 'Se inició correctamente la distribución de los rendimientos',
            close: 'Aceptar'
          }});

        } else {
          console.log('Cancelada')
        }
      });
      
    } catch (error) {
      console.log('Error al distribuir', error);

    }
  }

  private _updateDRStatus() {
    this.iRFileStatusRef = this.dataService.checkInvestmentReturnStatus(ContributionTypesEnum.CAR);
    this.iRFileStatusRef.child('status').on('value', async (snapshot: firebase.database.DataSnapshot) => {
      
      // this.uiService.showSpinner();
      
      this.iRStatus = snapshot.val();

      if (this.iRStatus === 'fileCreated') {
        await this.getDRValidationFile();
      }

      this.statusButton.nativeElement.click();

      // this.uiService.stopSpinner();
      
    });
  }

  changeStatus() {
    this.iRStatus = this.iRStatus;
  }

}
